import '@loyal_molecules/card.css'
import '@loyal_template/showcases.css'
import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import OwlCarousel from 'react-owl-carousel2'

const ShowcaseProductListWrapper = ({ children, viewAllPath, desktopItemsQty }) => {
  useEffect(() => {
    setTimeout(() => {
      const nextButton = document.querySelector('.bx-showcase-products .owl-nav')
      nextButton && nextButton.setAttribute('aria-hidden', true)
    }, 2000)
  }, [])

  const options = {
    margin: 10,
    autoplay: false,
    dots: false,
    rewind: true,
    loop: false,
    mouseDrag: false,
    pullDrag: false,
    freeDrag: false,
    responsive: {
      0: {
        items: 1,
        margin: 0,
        rewind: true,
        loop: false
      },
      400: {
        items: 2,
        margin: 0,
        rewind: true,
        loop: false
      },
      600: {
        items: 3,
        nav: true,
        rewind: true,
        loop: false
      },
      1000: {
        margin: 20,
        nav: true,
        rewind: true,
        loop: false,
        items: desktopItemsQty || 4
      }
    },
    navClass: [
      'pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon',
      'pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'
    ],
    navText: [
      '<i class="icon icon_left icon-sm color-ui-white" aria-hidden="true"></i>',
      '<i class="icon icon_right icon-sm color-ui-white" aria-hidden="true"></i>'
    ]
  }

  return (
    <div className='bx-showcase-products pos-relative'>
      <div className='row row-eq-height w-100'>
        <MediaQuery minDeviceWidth={481}>
          <OwlCarousel
            className='showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1'
            options={options}
          >
            {children}
          </OwlCarousel>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={480}>
          {children}
          <div className='col-12 px-half'>
            <Link
              to={viewAllPath}
              className='btn btn-sm txt-center txt-button btn-invert border-color-ui-2'
              role='button'
            >
              Ver todos
            </Link>
          </div>
        </MediaQuery>
      </div>
    </div>
  )
}

ShowcaseProductListWrapper.propTypes = {
  children: PropTypes.node,
  viewAllPath: PropTypes.string,
  desktopItemsQty: PropTypes.number
}

ShowcaseProductListWrapper.defaultProps = {
  viewAllPath: '/search'
}

export default ShowcaseProductListWrapper



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/ShowcaseProductListWrapper.js